import {
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';

export const daasPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'daas-frontend',
  extensions: [],
  routes: {
    root: rootRouteRef,
  },
});
